<dx-popup 
    [hideOnOutsideClick]="false"
    width="80%"
    height="80%"
    [(visible)]="option.showPdf"
    [resizeEnabled]="false"
    titleTemplate="title">

    <div *dxTemplate="let data of 'title'">
        <div class="popup-header-block">
            <div class="popup-title"></div>
            <dx-button (click)="option.showPdf=!option.showPdf" icon="close"></dx-button>
        </div>
    </div>

    <div *dxTemplate="let data of 'content'">

        <!-- <div *ngIf="!option.pdfUrl || option.pdfUrl==''" class="loader-box">
            <dx-load-indicator class="loader-indicator"></dx-load-indicator>
            <h6 class="loader-msg">Loading Report...</h6>
        </div> -->
            
        <dx-scroll-view width="100%" height="100%">

            <!-- <ngx-extended-pdf-viewer *ngIf="option.pdfUrl && option.pdfUrl!=''" [src]="option.pdfUrl" -->
            <ngx-extended-pdf-viewer src="assets/demo.pdf"
                [showToolbar]="true"
                [showSidebarButton]="false"
                [showFindButton]="false"
                [showPagingButtons]="false"
                [showZoomButtons]="true"
                [showPresentationModeButton]="false"
                [showOpenFileButton]="false"
                [showPrintButton]="true"
                [showDownloadButton]="true"
                [showDrawEditor]="false"
                [showStampEditor]="false"
                [showTextEditor]="false"
                [showSecondaryToolbarButton]="true"
                [showRotateButton]="false"
                [showHandToolButton]="false"
                [showScrollingButtons]="false"
                [showSpreadButton]="false"
                [showPropertiesButton]="false"
                [customToolbar]="multiToolbar"
                [filenameForDownload]="'pvr'"
                [pageViewMode]="'infinite-scroll'"

            ></ngx-extended-pdf-viewer>

            <ng-template #multiToolbar>
                <a target="_blank" routerLink="/assets/demo.pdf">OPEN</a>=
                <button id="download">Download</button>
                <button id="print">Print</button>
            </ng-template>

        </dx-scroll-view>
    </div>
</dx-popup>